import { Component, inject } from '@angular/core';
import { DataService } from '../../services/data.service';
import { GeoJsonFeature } from '../../models/geo-json-feature';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-accommodations',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './accommodations.component.html',
  styleUrl: './accommodations.component.css',
})
export class AccommodationsComponent {

  private dataService = inject(DataService);

  // Alojamientos agrupados por pueblo
  public accommodationsByPueblo: { [pueblo: string]: GeoJsonFeature[] } = {};
  public pueblosList: string[] = [];
  public loaded = false;

  // Accordion state
  public expandedLocations: { [key: string]: boolean } = {};

  constructor() {
    this.dataService.getGeoJson({ categoria: 'alo' }).subscribe(data => {
      const grouped: { [pueblo: string]: GeoJsonFeature[] } = {};

      for (const feature of data.features) {
        const pueblo = feature.properties.pueblo || feature.properties.obs || 'Otros';
        if (!grouped[pueblo]) {
          grouped[pueblo] = [];
        }
        grouped[pueblo].push(feature);
      }

      // Ordenar pueblos alfabéticamente
      this.pueblosList = Object.keys(grouped).sort();
      this.accommodationsByPueblo = grouped;
      this.loaded = true;
    });
  }

  toggleLocation(pueblo: string) {
    this.expandedLocations[pueblo] = !this.expandedLocations[pueblo];
  }

  extractMapsUrl(enlace: string): string {
    const match = enlace.match(/https?:\/\/[^\s]+/);
    return match ? match[0] : enlace;
  }
}
